// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o5bjJ","newExpiryDate":"styles_newExpiryDate__paTZ0","footer":"styles_footer__1bZ93"};